import { Flex, Inlinelink } from '@creditas-ui/react';
import { debounce } from 'lodash';
import type React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  type AppDispatch,
  type RootState,
  useAppDispatch,
} from '../../../store';
import { upsertFilters } from '../../../store/reducers/ejn-filters';

export const EjnPagination: React.FC = () => {
  const dispatch: AppDispatch = useAppDispatch();

  const { pageNumber, pageSize } = useSelector(
    (state: RootState) => state.extrajudicialNotificationsFiltersStore,
  );

  const { totalPages, numberOfElements, loading } = useSelector(
    (state: RootState) => state.extrajudicialNotificationsStore,
  );

  const handleClickPaginationDebounced = useCallback(
    debounce((pageNumber: number) => {
      dispatch(upsertFilters({ pageNumber }));
    }, 300),
    [],
  );

  return (
    <Flex flexDirection="row" spaceX="1rem">
      <Inlinelink
        onClick={() => handleClickPaginationDebounced(pageNumber - 1)}
        disabled={pageNumber <= 1 || totalPages <= 1 || loading}
      >
        {'<'}
      </Inlinelink>
      <p>
        pageNumber: {pageNumber} pageSize: {pageSize} totalPages: {totalPages}
        numberOfElements: {numberOfElements}
      </p>
      <Inlinelink
        onClick={() => handleClickPaginationDebounced(pageNumber + 1)}
        disabled={pageNumber >= totalPages || loading}
      >
        {'>'}
      </Inlinelink>
    </Flex>
  );
};
